import styled, { keyframes } from 'styled-components';
import { Form } from '@unform/web';

const appearFromTop = keyframes`
  from {
    opacity: 0;
    transform: translateY(-500px);
  }
  to {
    opacity: 1;
    transform: translateY(0px);
  }
`;

const appearBackground = keyframes`
  from {
    background-color: transparent;
  }
  to {
    background-color: rgba(0, 0, 0, 0.5);
  }
`;

export const Container = styled.div`
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgba(0, 0, 0, 0.5);
  width: 100%;
  height: 100%;
  position: fixed;
	top: 0;
  z-index: 10;
  animation: ${appearBackground} 0.5s;
  transition: ${appearBackground} 0.5s;

  .active {
    opacity: 1;
    top: 30%;
    visibility: visible;
    animation: ${appearFromTop} 0.4s;

    @media (max-width: 650px) {
      animation: ${appearFromTop} 0.4s;
    }
  }

  div::-webkit-scrollbar {
    display: none; /* Might be enough */
    background: transparent;
    visibility: hidden;
    width: 0px;
  }
  div {
    -ms-overflow-style: none;
    overflow: -moz-scrollbars-none;
    scrollbar-width: none;
  }
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  background: #fff;
  top: -500px;
  position: fixed;
  box-shadow: 0 1px 8px rgba(0, 0, 0, 0.3);
  opacity: 0;
  border-radius: 5px;
  width: 40%;
  padding: 20px 40px;
  visibility: hidden;
  transition: all 0.5s ease-out;

  h1 {
    font-size: 18px;
    font-weight: 500;
  }
  h2 {
    font-size: 18px;
    font-weight: 500;
    color: #455a64;
  }
`;

export const FormView = styled(Form)`
  display: flex;
  flex-direction: column;
  padding: 20px 0;

  div.input {
    display: flex;
    flex-direction: column;

    p {
      font-size: 0.9rem;
      font-weight: 500;
      margin: 5px 0;

      span {
        font-size: 0.8rem;
        color: #455a64;
      }
    }

    span {
      font-size: 0.8rem;
      font-weight: 500;
      color: #455a64;
      text-align: end;
      width: 100%;
      padding: 5px 10px 0 0;
    }
  }

  .div-comp {
    display: flex;
    flex-direction: column;
    padding-top: 20px;

    h1 {
      font-size: 16px;
    }
    h2 {
      font-size: 14px;
      // margin-bottom: -10px;
    }
  }

  button {
    font-size: 18px;
    font-weight: 500;
    color: var(--azul-razio);
    border: 2px solid var(--azul-razio);
    border-radius: 8px;
    padding: 7px 30px;
    width: 100%;
    margin: 10px 0;
  }

  .btn-buscar {
    color: #fff;
    background-color: var(--azul-razio);
    margin-top: 20px;
  }
`;
